export default "__VITE_ASSET__By_Ykjh7__"